import classNames from "classnames"

const TileFooter = (props) => {

    const { classes, align } = props
    const className = classNames(classes, "tile-footer")
    const style = (align === "right") ? {
        textAlign: "right"
    } : {}

    return (
        <div style={style} className={className}>{props.children}</div>
    )
}

export default TileFooter